import ApiConfig from "../../../api/api.config";

const apiUrl = `${ApiConfig.getEntryPoint()}`;

export const getArticleZipAttachmentsUrl = (articleId: number) =>
    `${apiUrl}articles/${articleId}/zip-attachments`;